// @saas/interactions 包入口
// 题型注册行随各渲染器 Task 追加。
import { registerRenderer, getRenderer, registeredKeys } from './registry'
import { parseInit, buildReply, MSG_TYPES } from './protocol'
import ChoiceRenderer from './renderers/ChoiceRenderer.vue'
import FillBlankRenderer from './renderers/FillBlankRenderer.vue'
import ShortAnswerRenderer from './renderers/ShortAnswerRenderer.vue'
import MatchingRenderer from './renderers/MatchingRenderer.vue'

registerRenderer('single_choice', ChoiceRenderer)
registerRenderer('multi_choice', ChoiceRenderer)
registerRenderer('judgment', ChoiceRenderer)
registerRenderer('fill_blank', FillBlankRenderer)
registerRenderer('short_answer', ShortAnswerRenderer)
registerRenderer('matching', MatchingRenderer)

export { registerRenderer, getRenderer, registeredKeys, parseInit, buildReply, MSG_TYPES }
